import { render, staticRenderFns } from "./coin_management.vue?vue&type=template&id=3adb65c3&scoped=true"
import script from "./coin_management.vue?vue&type=script&lang=js"
export * from "./coin_management.vue?vue&type=script&lang=js"
import style0 from "./coin_management.vue?vue&type=style&index=0&id=3adb65c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb65c3",
  null
  
)

export default component.exports